import { useState, useCallback } from "react";
import { Card } from "@/types/v2";

export interface UseMoveToDialogOptions {
  onMoveSuccess?: (card: Card, newContainer: string) => void;
  onEagerUpdate?: (card: Card, newContainer: string) => void;
}

export interface UseMoveToDialogResult {
  isOpen: boolean;
  selectedCard: Card | undefined;
  openDialog: (card: Card) => void;
  closeDialog: () => void;
  handleMoveSuccess: (card: Card, newContainer: string) => void;
}

export const useMoveToDialog = (
  options: UseMoveToDialogOptions = {}
): UseMoveToDialogResult => {
  const { onMoveSuccess, onEagerUpdate } = options;
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState<Card | undefined>(undefined);

  const openDialog = useCallback((card: Card) => {
    setSelectedCard(card);
    setIsOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setIsOpen(false);
    setSelectedCard(undefined);
  }, []);

  const handleMoveSuccess = useCallback(
    (card: Card, newContainer: string) => {
      // Call eager update first if provided (for immediate UI updates)
      onEagerUpdate?.(card, newContainer);

      // Call the success callback if provided
      onMoveSuccess?.(card, newContainer);

      console.log(
        `Successfully moved card ${card.id} to container ${newContainer}`
      );

      closeDialog();
    },
    [closeDialog, onMoveSuccess, onEagerUpdate]
  );

  return {
    isOpen,
    selectedCard,
    openDialog,
    closeDialog,
    handleMoveSuccess,
  };
};
